function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 56,
  height: 56,
  rx: 28,
  fill: "#FEE2E2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.666 32.5003H29.3327V35.167H26.666V32.5003ZM26.666 21.8337H29.3327V29.8337H26.666V21.8337ZM27.986 15.167C20.626 15.167 14.666 21.1403 14.666 28.5003C14.666 35.8603 20.626 41.8337 27.986 41.8337C35.3594 41.8337 41.3327 35.8603 41.3327 28.5003C41.3327 21.1403 35.3594 15.167 27.986 15.167ZM27.9993 39.167C22.106 39.167 17.3327 34.3937 17.3327 28.5003C17.3327 22.607 22.106 17.8337 27.9993 17.8337C33.8927 17.8337 38.666 22.607 38.666 28.5003C38.666 34.3937 33.8927 39.167 27.9993 39.167Z",
  fill: "#B91C1C"
});

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.d74609e2.svg";
export { ForwardRef as ReactComponent };